import * as React from "react";
const CryIcon = ({ brandingColor = "#22880" }: any) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 162 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    preserveAspectRatio="xMidYMin meet"
    aria-hidden="false"
  >
    <path
      d="M148.667 109.001C159.766 77.8995 149.218 43.1976 122.688 23.5334C96.1584 3.86909 59.8889 3.86909 33.3592 23.5334C6.82939 43.1976 -3.71856 77.8995 7.38034 109.001"
      stroke="#F2FCEE"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M152.667 105.001C163.766 73.8995 153.218 39.1976 126.688 19.5334C100.158 -0.130912 63.8889 -0.130912 37.3592 19.5334C10.8294 39.1976 0.281439 73.8995 11.3803 105.001"
      stroke="#373737"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M125.169 60.0005C123.052 54.0055 117.384 49.9971 111.026 49.9971C104.668 49.9971 99.0007 54.0055 96.8828 60.0005"
      stroke="#373737"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M66.8726 60.0005C64.7547 54.0055 59.0873 49.9971 52.7293 49.9971C46.3712 49.9971 40.7039 54.0055 38.5859 60.0005"
      stroke="#373737"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72 105C72 99.4772 76.4772 95 82 95V95C87.5228 95 92 99.4772 92 105V115C92 120.523 87.5228 125 82 125V125C76.4772 125 72 120.523 72 115V105Z"
      stroke="#373737"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M32 85V135V135C23.7157 135 17 141.716 17 150C17 152.761 19.2386 155 22 155H62C64.7614 155 67 152.761 67 150C67 141.716 60.2843 135 52 135V85"
      stroke={brandingColor}
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M112 85V135V135C103.716 135 97 141.716 97 150C97 152.761 99.2386 155 102 155H142C144.761 155 147 152.761 147 150C147 141.716 140.284 135 132 135V85"
      stroke={brandingColor}
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export default CryIcon;
